import { render } from "./AccordionItemEditor.vue?vue&type=template&id=63e13fbe&scoped=true&lang=pug"
import script from "./AccordionItemEditor.vue?vue&type=script&lang=js"
export * from "./AccordionItemEditor.vue?vue&type=script&lang=js"

import "./AccordionItemEditor.vue?vue&type=style&index=0&id=63e13fbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e13fbe"]])

export default __exports__